import { render } from "./teluser.vue?vue&type=template&id=46479b7b"
import script from "./teluser.vue?vue&type=script&lang=js"
export * from "./teluser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__